import { render } from "./Skeleton.vue?vue&type=template&id=16370142&scoped=true"
import script from "./Skeleton.vue?vue&type=script&lang=js"
export * from "./Skeleton.vue?vue&type=script&lang=js"

import "./Skeleton.vue?vue&type=style&index=0&id=16370142&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16370142"]])

export default __exports__